<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款'" name="obligation">
            <span slot="label">未付款
              <el-tag size="mini">{{ order_count.obligation }}</el-tag>
            </span>
          </el-tab-pane>
          <!-- confirmed -->
          <el-tab-pane :label="'待发货'" name="delivery">
            <span slot="label">待发货
              <el-tag size="mini">{{ order_count.delivery }}</el-tag>
            </span>
          </el-tab-pane>
          <el-tab-pane :label="'待收货'" name="receive">
            <span slot="label">待收货
              <el-tag size="mini">{{ order_count.receive }}</el-tag>
            </span>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="received">
            <span slot="label">已完成
              <el-tag size="mini">{{ order_count.received }}</el-tag>
            </span>
          </el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%"
          v-loading="loading">
          <el-table-column prop="orderNo" label="订单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{ 'state-text-red': scope.row.order_source != 10 }">{{
                  scope.row.order_source_text }}</span>
                <span class="c_main">订单号：{{ scope.row.orderNo }}</span>
                <span class="pl16">下单时间：{{ scope.row.createTime }}</span>
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.maproduct" :key="index">
                  <!-- <div class="pic"><img v-img-url="item.image.filePath" alt="" /></div> -->
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.productName }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                    <div class="orange" v-if="item.refund">{{ item.refund.type.text }}-{{ item.refund.status.text }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.productPrice }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实际支付" width="150">
            <template slot-scope="scope">
              <div class="orange">{{ scope.row.pay_price }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="技师信息">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.waiter.username }}
                <span class="gray9">ID：({{ scope.row.waiter.waiter_user_id }})</span>
              </div>
              <el-image :src='scope.row.waiter.avatarUrl' style="width:30px;height:30px"></el-image><br />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="waiter.mobile" label="技师号码">
            <template slot-scope="scope">
              {{ scope.row.waiter?scope.row.waiter.mobile:'--' }}
            </template>
          </el-table-column> -->
          <el-table-column prop="pay_status" label="交易状态">
            <template slot-scope="scope">
              {{ scope.row.pay_status ? scope.row.pay_status.text : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="address" label="收货地址">
            <template slot-scope="scope">
              {{ scope.row.address ? scope.row.address.region.province : '' }}
              {{ scope.row.address ? scope.row.address.region.region : '' }}
              {{ scope.row.address ? scope.row.address.region.city : '' }}{{ scope.row.address ? scope.row.address.detail
                : '' }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope"
              v-if="scope.row.delivery_status && scope.row.order_status && scope.row.pay_status && scope.row.receipt_status">
              <!-- $data['pay_status'] ==20 && $data['order_status'] == 10 && $data['receipt_status'] == 10 && $data['delivery_status'] == 10) -->
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10 && scope.row.order_status.value == 10 && scope.row.receipt_status.value == 10"
                @click="reClick(scope.row)" type="primary" size="small">确认发货</el-button>
              <el-button v-else :disabled='true' type="primary" size="small">确认发货</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import materialApi from "@/api/material.js";
import qs from "qs";
export default {
  components: {
    // Logistics
  },
  data() {
    return {
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        orderNo: "",
        style_id: "",
        createTime: ""
      },

      /*门店列表*/
      shopList: [],
      /*时间*/
      createTime: "",
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        all: 0,
        obligation: 0,
        receive: 0
      },
      isLogistics: false,
      logisticsData: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*删除用户*/
    reClick(row) {
      let self = this;
      self
        .$confirm("确定发货吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          OrderApi.deliveryorder(
            {
              orderId: row.orderId
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: data.msg,
                  type: "success"
                });
                self.getData();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => { });
    },

    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      console.log(self.activeName);
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      materialApi
        .materialOrder(Params, true)
        .then(res => {
          console.log("======res", res);
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              orderNo: item.orderNo,
              createTime: item.createTime,
              order_source: item.order_source,
              order_source_text: item.order_source_text,
              is_top_row: true,
              order_status: item.order_status.value
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;
          self.totalDataNumber = res.data.list.total;
          // 统计
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => { });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/materials/order/index.vue